import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { LocalStorageService } from 'angular-2-local-storage';

/*
  Generated class for the CustomStorageProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class CustomStorageProvider {
  supportLocalStorage: boolean = false;
  memoryStorage: Object;

  constructor(public localStorageService: LocalStorageService) {
    this.memoryStorage = new Object();
    this.localStorageService.set("test", "testing");
    if (this.localStorageService.get("test") == "testing") {
      this.supportLocalStorage = true;
    } else {
      this.supportLocalStorage = false;
    }
  }

  public get<T>(key: string): T {
    if (this.supportLocalStorage) {
      return this.localStorageService.get<T>(key);
    } else {
      return this.memoryStorage[key];
    }
  }

  public set(key: string, obj: any): boolean {
    if (this.supportLocalStorage) {
      return this.localStorageService.set(key, obj);
    } else {
      this.memoryStorage[key] = obj;
      return true;
    }
  }

  public remove(key: string): boolean {
    if (this.supportLocalStorage) {
      return this.localStorageService.remove(key);
    } else {
      this.memoryStorage[key] = null;
      return true;
    }
  }

  public clearAll(): boolean {
    if (this.supportLocalStorage) {
      return this.localStorageService.clearAll();
    } else {
      this.memoryStorage = null;
      return true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/custom-storage/custom-storage.ts